// /api/authService.js
import axiosInstance from './axiosInstance';

import axios from 'axios';

const baseAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export default {
  login(credentials) {
    return baseAxiosInstance.post('/login/', credentials);
  },
  register(credentials) {
    return baseAxiosInstance.post('/register/', credentials);
  },
  refreshToken(refreshToken) {
    return baseAxiosInstance.post('/auth/refresh_token', { refresh_token: refreshToken });
  },
  requestEmailVerificationCode(email) {
    return axiosInstance.post('/verification/request-email-code', { email });
  },
  verifyEmail(email, code) {
    return axiosInstance.post('/verification/verify-email', { email, code });
  },
  requestSmsVerificationCode(phone_number) {
    return axiosInstance.post('/verification/request-sms-code', { phone_number });
  },
  verifyPhoneNumber(phone_number, code) {
    return axiosInstance.post('/verification/verify-phone', { phone_number, code });
  },
  getGmailAuthorizationUrl(redirectTo) {
    return axiosInstance.get('/gmail/authorize-url', {
      params: { redirect_to: redirectTo },
    });
  },
  completeGmailAuthorization(code, state) {
    return axiosInstance.post('/gmail/callback-api', {
      code,
      state,
    });
  },
  getOutlookAuthorizationUrl(redirectTo) {
    return axiosInstance.get('/outlook/authorize-url', {
      params: { redirect_to: redirectTo },
    });
  },
  completeOutlookAuthorization(code, state) {
    return axiosInstance.post('/outlook/callback-api', {
      code,
      state,
    });
  },
  getTwilioToken() {
    return axiosInstance.post('/calls/token');
  },
};
